// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__OFlJB","addWidgetButton":"Header_addWidgetButton__2LK8B","dashboardTabs":"Header_dashboardTabs__3dTmR","active":"Header_active__6foAB"};